
export default () => ({
    loading: true,
    provinces: [],
    currentEntity: null
})
